import React from "react";

import FBContent from "../templates/FBContent"
import mapDetailsLabels from "../../assets/project-assets/mapDetailsLabels";

import { ReactComponent as ProcessElement } from "../../assets/project-assets/project-steps/process-element.svg";


import { ReactComponent as MapTileDeveloper } from "../../assets/project-assets/markdown-icons/map-tile-developer.svg";
import { ReactComponent as MapTileProjectCompany } from "../../assets/project-assets/markdown-icons/map-tile-projectcompany.svg";
import { ReactComponent as MapTileVault } from "../../assets/project-assets/markdown-icons/map-tile-vault.svg";
import { ReactComponent as MapTileInvestor } from "../../assets/project-assets/markdown-icons/map-tile-investor.svg";
import { ReactComponent as MapTileBank } from "../../assets/project-assets/markdown-icons/map-tile-bank.svg";
import { ReactComponent as MapTileProject } from "../../assets/project-assets/markdown-icons/map-tile-project.svg";
import { ReactComponent as MapTileReview } from "../../assets/project-assets/markdown-icons/map-tile-review.svg";
import { ReactComponent as MapTileSold } from "../../assets/project-assets/markdown-icons/map-tile-sold.svg";
import { ReactComponent as MapTileFB } from "../../assets/project-assets/markdown-icons/map-tile-fundbricks.svg";


import { createEnDaContent, lang, translateContent } from '../../globals/Translations';
import ProjectContent from "../../shared/ProjectContent";
import { ColumnFlexBox, RowFlexBox } from "../templates/Wrappers";
import colors from "../../globals/colors";
import { ContentType } from "../../shared/Globals";
import ProjectContentTable from "../molecules/ProjectContentTable";


type StepTile = { title: string, label: string, text: string, image?: React.FC, element?: JSX.Element }
const StepTileComponent: React.FC<{ tile: StepTile, contentType: ContentType, index: number }> = ({ tile, contentType, index }) => {

    const ImageObject = tile.image

    return (
        <ColumnFlexBox style={{ marginTop: 64 }} className="content-block">
            {ImageObject && <ImageObject />}
            <h3 style={{ marginTop: 12, marginBottom: 12 }}>{index}. {tile.title}</h3>
            <div style={{
                backgroundColor: colors.light, WebkitPrintColorAdjust: "exact",
                paddingLeft: 32, paddingRight: 32, paddingTop: 12, paddingBottom: 12
            }}>
                <p style={{ color: colors.dark }}>{tile.label}</p>
            </div>

            <FBContent content={tile.text} contentType={contentType} />
            {tile.element}
        </ColumnFlexBox>
    )
}


export const ProjectMapPrintable: React.FC<{ localizedContent: ProjectContent }> = ({ localizedContent }) => {
    const investmentDescription = localizedContent.investmentDescription || ""
    const developerDescription = localizedContent.developerDescription || ""
    const projectCompanyDescription = localizedContent.projectCompanyDescription || ""
    const vaultDescription = localizedContent.vaultDescription || ""
    const crowdinvestorDescription = localizedContent.crowdinvestorDescription || ""
    const bankDescription = localizedContent.bankDescription || ""
    const fundbricksFeeDescription = localizedContent.fundbricksFeeDescription || ""
    const projectDescription = localizedContent.projectDescription || ""
    const buildReviewDescription = localizedContent.buildReviewDescription || ""
    const sellingPeriodDescription = localizedContent.sellingPeriodDescription || ""
    const paybackDescription = localizedContent.paybackDescription || ""
    const paybackBankDescription = localizedContent.paybackBankDescription || ""
    const paybackCrowdInvestoorDescription = localizedContent.paybackCrowdInvestoorDescription || ""
    const paybackDeveloperDescription = localizedContent.paybackDeveloperDescription || ""
    const riskDescription = localizedContent.riskDescription || ""


    const stepContents: StepTile[] = [
        {
            title: mapDetailsLabels.investment.title,
            label: mapDetailsLabels.investment.label,
            text: investmentDescription,
        },
        {
            title: mapDetailsLabels.developer.title,
            label: mapDetailsLabels.developer.label,
            text: developerDescription,
            image: MapTileDeveloper
        },
        {
            title: mapDetailsLabels.projectcompany.title,
            label: mapDetailsLabels.projectcompany.label,
            text: projectCompanyDescription,
            image: MapTileProjectCompany
        },
        {
            title: mapDetailsLabels.vault.title,
            label: mapDetailsLabels.vault.label,
            text: vaultDescription,
            image: MapTileVault
        },
        {
            title: mapDetailsLabels.crowdinvestor.title,
            label: mapDetailsLabels.crowdinvestor.label,
            text: crowdinvestorDescription,
            image: MapTileInvestor
        },
        {
            title: mapDetailsLabels.bank.title,
            label: mapDetailsLabels.bank.label,
            text: bankDescription,
            image: MapTileBank
        },
        {
            title: mapDetailsLabels.fb.title,
            label: mapDetailsLabels.fb.label,
            text: fundbricksFeeDescription
        },
        {
            title: mapDetailsLabels.project.title,
            label: mapDetailsLabels.project.label,
            text: projectDescription,
            image: MapTileProject
        },
        {
            title: mapDetailsLabels.review.title,
            label: mapDetailsLabels.review.label,
            text: buildReviewDescription,
            image: MapTileReview
        },
        {
            title: mapDetailsLabels.sold.title,
            label: mapDetailsLabels.sold.label,
            text: sellingPeriodDescription,
            image: MapTileSold
        },
        {
            title: mapDetailsLabels.payback.title,
            label: mapDetailsLabels.payback.label,
            text: paybackDescription,
            image: MapTileInvestor
        },
        {
            title: mapDetailsLabels.bankreturn.title,
            label: mapDetailsLabels.bankreturn.label,
            text: paybackBankDescription,
            image: MapTileInvestor
        },
        {
            title: mapDetailsLabels.crowdinvestorreturn.title,
            label: mapDetailsLabels.crowdinvestorreturn.label,
            text: paybackCrowdInvestoorDescription,
            image: MapTileInvestor
        },
        {
            title: mapDetailsLabels.developerreturn.title,
            label: mapDetailsLabels.developerreturn.label,
            text: paybackDeveloperDescription,
            image: MapTileInvestor
        },
        {
            title: mapDetailsLabels.economy.title,
            label: mapDetailsLabels.economy.label,
            text: "",
            element: <ProjectContentTable table={localizedContent.economy} />
        },
        {
            title: mapDetailsLabels.risks.title,
            label: mapDetailsLabels.risks.label,
            text: riskDescription
        }
    ]

    return (
        <ColumnFlexBox>

            <h3>1. Introduktion til Fundbricks.com</h3>
            <h4>1.1 Fundbricks.com</h4>
            <FBContent content={translateContent(createEnDaContent(AboutFundbricksElementsEn.first, AboutFundbricksElementsDa.first))} contentType={ContentType.HTML} />
            <h4>1.2 Hvad er crowdlending</h4>
            <FBContent content={translateContent(createEnDaContent(AboutFundbricksElementsEn.second, AboutFundbricksElementsDa.second))} contentType={ContentType.HTML} />
            <h4>1.3 Hvordan fungerer det?</h4>
            <FBContent content={translateContent(createEnDaContent(AboutFundbricksElementsEn.third, AboutFundbricksElementsDa.third))} contentType={ContentType.HTML} />
            <ProcessElement height="500px"/>
            {stepContents.map((item, index) => <StepTileComponent tile={item} key={index} index={index + 2} contentType={localizedContent.contentType} />)}

        </ColumnFlexBox>
    )
}

const AboutFundbricksElementsEn = {
    first: "<p>Fundbricks.com allows investors to lend their wealth to attractive European real estate projects and renewable energy projects at a high interest rate and short term. Fundbricks.com offers an online platform that project developers can use to market their solid projects and find potential investors.</p><p>Fundbricks.com receives its fee from the project developers who use the platform. The fee is primarily based on a success fee, i.e., Fundbricks.com only gets paid when a project has achieved the necessary financing. <strong>It is free for investors to use the platform</strong>.</p><p>The crowdlending platform Fundbricks.com is owned and operated by Fundbricks.com ApS, Strandvejen 100, 2900 Hellerup, CVR: 40431934.</p><p>If you have questions or comments, we would love to hear from you at tel.: 7023 0101 or email <a target='_blank' href=\"mailto:hello@fundbricks.com\">hello@fundbricks.com</a> </p>",
    second: "<p>Crowdlending is a method where private investors can lend their wealth to investment projects with the aim of earning an interest profit. At Fundbricks.com, your wealth is lent to project developers who have exciting real estate projects or renewable energy projects with significant financial coverage, and who need capital to realize the projects.</p><p>The project developer gets the opportunity to realize his projects and secure a profit. The investor gets a high interest rate and short term - typically 8-12% p.a., term of 6-18 months, and collateral.</p>",
    third: "<p>We have illustrated the overall process of how lending is done through Fundbricks.com.</p><p>It illustrates the process from the developer presenting a solid project, to crowd investors and possibly a bank lending to the construction/project, to the project being built and continuously monitored by a construction expert, to the completed construction being sold with profit and the lent funds finally being repaid to the bank, crowd investors, and the developer himself.</p><p>In the following pages, we will explain in detail about each point. Just look for the icons on the point you are looking for.</p><p>The illustration can also be seen in full size on the last page of this document. You can also experience an interactive illustration on the project page at <a target='_blank' href=\"http://www.fundbricks.com\">www.fundbricks.com</a>.</p>"
}

const AboutFundbricksElementsDa = {
    first: "<p>Fundbricks.com gør det muligt for investorer at udlåne deres formue til attraktive europæiske ejendomsprojekter og projekter indenfor vedvarende energi til en høj rente og kort løbetid. Fundbricks.com tilbyder en online platform, som projektudviklere kan bruge til at markedsføre deres solide projekter og finde potentielle investorer.</p><p>Fundbricks.com modtager sit honorar fra de projektudviklere, som benytter platformen. Honoraret er i det væsentligste baseret på et Kapitalformidlings honorar, dvs. at Fundbricks.com først får betaling, når et projekt har opnået den nødvendige finansiering. <strong>Det er gratis for investorer at benytte platformen</strong>.</p><p>Crowdlending-platformen Fundbricks.com ejes og drives af Fundbricks.com ApS, Strandvejen 100, 2900 Hellerup, CVR: 40431934.</p><p>Har du spørgsmål eller kommentarer hører vi gerne fra dig på tlf.: 7023 0101 eller email <a target='_blank' href=\"mailto:hello@fundbricks.com\">hello@fundbricks.com</a> </p>",
    second: "<p>Crowdlending er en metode hvor private investorer kan udlåne sin formue til investeringsprojekter med henblik på at optjene en rentegevinst. Hos Fundbricks.com udlånes din formue til projektudviklere, som har spændende ejendomsprojekter eller projekter med vedvarende energi med stor økonomisk overdækning, og som har behov for kapital, for at kunne realisere projekterne.</p><p>Projektudvikleren får mulighed for at realisere sine projekter og sikre sig en profit. Investor får høj rente og kort løbetid - typisk 8-12% p.a., løbetid på 6-18 mdr. og sikkerhedsstillelse.</p>",
    third: "<p>Vi har illustreret den overordnede proces for hvordan udlån foretages gennem Fundbricks.com.</p><p>Den illustrerer processen fra udvikler kommer med et solidt projekt, til crowdinvestorer og evt. bank udlåner til byggeriet/projektet, til projektet bliver opført og løbende kontrolleret af byggesagkyndig, til det færdige byggeri sælges med profit og til at de udlånte midler til sidst tilbagebetales til henholdsvis bank, crowdinvestorer og udvikleren selv.</p><p>På de følgende sider vil vi forklare i detaljer om hvert punkt. Se blot efter ikonerne på det punkt, du søger.</p><p>Illustrationen kan også ses i fuld størrelse på den sidste side i dette dokument. Du kan også opleve en interaktiv illustration på projektsiden på <a target='_blank' href=\"http://www.fundbricks.com\">www.fundbricks.com</a>.</p>"
}
